import React, {
  useContext, useEffect, useState,
} from 'react';
import { mdiClose, mdiAlertOutline } from '@mdi/js';
import { useSelector } from 'react-redux';
import { ApiContext } from '../../api/ApiContextProvider';
import { getMeIsRootOrAdmin } from '../../profile/selectors';
import BaseIcon from '../../_ui/BaseIcon/BaseIcon';
import BaseButton from '../../_ui/BaseButton/BaseButton';
import { dateFormat54origins } from '../../54origins/utils54origins';

function HoneypotAlertBanner() {
  const { requestGetLastHoneypotAlert, requestAcknowledgeHoneypotAlert } = useContext(ApiContext);
  const meIsRootOrAdmin = useSelector(getMeIsRootOrAdmin);

  const [alert, setAlert] = useState(null);
  const [count, setCount] = useState(0);

  const fetchAlert = () => {
    if (!meIsRootOrAdmin) return;
    requestGetLastHoneypotAlert()
      .then((res) => {
        setAlert(res?.alert || null);
        setCount(res?.count || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchAlert();
    const interval = setInterval(fetchAlert, 30000);
    return () => clearInterval(interval);
  }, [meIsRootOrAdmin]);

  const handleDismiss = () => {
    requestAcknowledgeHoneypotAlert()
      .then(() => {
        setAlert(null);
        setCount(0);
      })
      .catch(() => {});
  };

  if (!meIsRootOrAdmin || !alert) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        background: '#fff1f0',
        border: '1px solid #ffa39e',
        borderRadius: 6,
        padding: '6px 14px',
        fontSize: 13,
        color: '#cf1322',
        width: '100%',
        maxWidth: 560,
      }}
    >
      <BaseIcon path={mdiAlertOutline} size={0.8} color="#cf1322" />
      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {count > 1 && <strong style={{ marginRight: 4 }}>{`[${count}]`}</strong>}
        {`Honeypot: ${alert.ip_address || '?'}`}
        {alert.created && (
          <span style={{ color: '#8c8c8c', marginLeft: 6 }}>
            {dateFormat54origins(alert.created).dateWithTime}
          </span>
        )}
      </span>
      <BaseButton
        className="button-secondary-link"
        size="small"
        onClick={handleDismiss}
        style={{ color: '#cf1322', minWidth: 'unset', padding: 0 }}
      >
        <BaseIcon path={mdiClose} size={0.8} />
      </BaseButton>
    </div>
  );
}

export default HoneypotAlertBanner;
